<template>
  <div class="moon-day white-wrapper mt-3">
    <div class="moon-day__info" :class="{
      'moon-day__info-positive': isPositiveDay,
      'moon-day__info-neutral': isNeutralDay,
      'moon-day__info-negative': isNegativeDay
    }">

      <div v-if="isPositiveDay">
        <img src="https://vk.com/emoji/e/f09f918d_2x.png" class="moon-day__info_icon"/>
        <span>Благоприятный день</span>
      </div>

      <div v-if="isNeutralDay">
        <img src="https://vk.com/emoji/e/f09f9982_2x.png" class="moon-day__info_icon"/>
        <span>Обычный день</span>
      </div>

      <div v-if="isNegativeDay">
        <img src="https://vk.com/emoji/e/f09f9981_2x.png"  class="moon-day__info_icon"/>
        <span>Неблагоприятный день</span>
      </div>
    </div>

    <div class="moon-day__description">
      <p>{{ sentences[0] }}</p>
      <accordion>
        <div slot="body">
          <p v-for="s in sentences.slice(1, sentences.length)" :key="s.length + Math.random()">
            {{ s }}
          </p>
        </div>
      </accordion>
    </div>
  </div>
</template>

<script>
import {store} from "@/store";
import stringHelper from "@/lib/string";
import Accordion from "@/components/_Utlis/Accordion";

export default {
  name: "MoonDayWidget",
  components: {Accordion},
  data() {
    return {
      sentences: [],
    }
  },
  created() {
    this.sentences = stringHelper.generateText(this.moonDayData);
  },
  computed: {
    moonDayData() {
      return store.state.moonDayInfo["description_moon_day"];
    },
    isPositiveDay() {
      return store.state.moonDayInfo["favorability_day"] === "positive";
    },
    isNeutralDay() {
      return store.state.moonDayInfo["favorability_day"] !== "positive" && store.state.moonDayInfo["favorability_day"] !== "negative";
    },
    isNegativeDay() {
      return store.state.moonDayInfo["favorability_day"] === "negative";
    },
  }
}
</script>

<style lang="scss" scoped>
  .moon-day__info {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 500;
    padding: 4px 10px;
    border: 1px solid #bdbdbd;
    border-radius: 5px;
    margin-top: 7px;
    margin-bottom: 14px;
    color: #333;

    & img {
      margin-right: 7px;
    }
  }

  .moon-day__info-positive {
    background: #c8e6c9;
    border-color: #a5d6a7;
  }

  .moon-day__info-neutral {
    background: #f5f5f5;
    border-color: #eeeeee;
  }

  .moon-day__info-negative {
    background: #ffcdd2;
    border-color: #ef9a9a;
  }

  .moon-day__info-description {

  }

  .moon-day__info_icon {
    width: 16px;
    height: auto;
    margin-top: -4px;
  }
</style>